"use strict";

var app = angular.module('rmAuth');

app.controller('AuthLoginCtrl', require('./auth_login_ctrl'));
app.controller('AuthLostPasswordCtrl', require('./auth_lost_password_ctrl'));
app.controller('AuthPasswordResetCtrl', require('./auth_password_reset_ctrl'));
app.controller('AuthRegisterCtrl', require('./auth_register_ctrl'));
app.controller('AuthInviteCtrl', require('./auth_invite_ctrl'));
app.controller('ExternalRegisterCtrl', require('./external_register_ctrl'));
